import styled from "styled-components";

// styles
export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  height: 58px;
  .img {
    border-radius: 50%;
    object-fit: cover;
  }
  .column-flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 80%;
  }
  .specialties {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 400;
    color: rgba(117, 117, 117, 1);
    margin: 0 !important;
  }
  .name {
    font-size: 15px;
    font-weight: 500;
    color: rgba(65, 65, 65, 1);
    line-height: 36px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 !important;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column !important;
  align-items: flex-start;
  gap: 20px;
  margin-top: 80px;
  height: auto;
  padding-bottom: 160px;
  ${(p) =>
    p.inModal &&
    `
        margin-top: 0px !important;
        padding-bottom: 0px !important;
    `}
  @media (max-width: 600px) {
    margin-top: 60px;
    ${(p) =>
      p.inModal &&
      `
            margin-top: 0px !important;
        `}
  }
  .flex-column-container {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row !important;
    align-items: flex-start;
    gap: 25px;
    height: auto;
    @media (max-width: 900px) {
      flex-direction: column;
    }
  }
  div {
    ${(p) =>
      p.webConfig.dir === "ltr" &&
      `
		    direction: ltr !important;
		    text-align: left;
	`}
  }
  .doctor-image {
    width: 90px !important;
    height: 90px !important;
    border-radius: 50%;
    .img {
      border-radius: 50%;
      object-fit: cover;
    }
  }
  .fixed-button {
    @media (min-width: 901px) {
      display: none;
    }
    position: fixed;
    bottom: 105px;
    left: 0;
    width: 100%;
    background: white;
    padding: 16px;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
    z-index: 999;
    cursor: pointer;
    ${(p) =>
      p.appPromptClose &&
      `
            bottom: 50px;
        `}
    ${(p) =>
      !p.isMobile &&
      `
            bottom: 50px;
        `}
        .button {
      width: 100%;
      height: 42px;
    }
  }
  .first-column {
    width: calc(100% - 411px);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    @media (max-width: 900px) {
      width: 100%;
    }
  }
  .second-column {
    position: absolute;
    width: 386px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    ${(p) =>
      p.webConfig.dir === "ltr"
        ? `
            right: 0;
        `
        : `
            left: 0;
        `}
    @media (max-width: 900px) {
      display: none;
    }
    .loading {
      margin: auto;
      margin-top: 80px;
    }
  }
  .is-sticky {
    position: fixed;
    width: 386px;
    top: 78px;
    z-index: 999;
    animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;
    ${(p) =>
      p.webConfig.dir === "ltr"
        ? `
            right: 112px;

        `
        : `
            left: 112px;

        `}
    @media (max-width: 1400px) {
      ${(p) =>
        p.webConfig.dir === "ltr"
          ? `
                right: 70px;
            `
          : `
                left: 70px;
            `}
    }
    @media (max-width: 1200px) {
      ${(p) =>
        p.webConfig.dir === "ltr"
          ? `
                right: 40px;
            `
          : `
                left: 40px;
            `}
    }
    @media (max-width: 1000px) {
      ${(p) =>
        p.webConfig.dir === "ltr"
          ? `
                right: 30px;
            `
          : `
                left: 30px;
            `}
    }
    @media (max-width: 900px) {
      ${(p) =>
        p.webConfig.dir === "ltr"
          ? `
                right: 20px;
            `
          : `
                left: 20px;
            `}
    }
  }
  .is-fixed {
    position: absolute;
    top: auto;
    bottom: 0;
    z-index: 0;
    animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;
    ${(p) =>
      p.webConfig.dir === "ltr"
        ? `
            right: 0;
        `
        : `
            left: 0;
        `}
  }
  .padding-24 {
    padding: 24px;
    @media (max-width: 600px) {
      padding: 16px;
    }
  }
  .box {
    width: 100%;
    border-radius: 16px;
    height: auto;
    background: #fff;
    .header {
      display: block;
      width: 100% !important;
      height: 220px;
      position: relative;
      border-radius: 16px;
      @media (max-width: 600px) {
        height: 160px;
      }
      .cover {
        width: 100% !important;
        height: 220px;
        object-fit: cover;
        border-radius: 16px;
        @media (max-width: 600px) {
          height: 160px;
        }
      }
    }
    .margin-1 {
      margin: -1px 0;
    }
    .name {
      font-size: 24px;
      font-weight: 700;
      margin-bottom: -10px;
      margin-top: 0;
      @media (max-width: 600px) {
        font-size: 20px;
      }
    }
    .description {
      margin-bottom: 20px !important;
    }
    .about {
      color: #72767a;
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
    }
    .center-image {
      display: block;
      width: 100px;
      height: 100px;
      border-radius: 10px;
      top: -48px;
      right: 24px;
      position: absolute;
      border: 2px solid #fff;
      background-color: #fff;
      ${(p) =>
        p.webConfig.dir === "ltr" &&
        `
               left: 24px;
               @media (max-width: 600px) {
                    left: 16px;
                }
	        `}
      @media (max-width: 600px) {
        top: -32px;
        right: 16px;
        width: 68px;
        height: 68px;
      }
      .img {
        border-radius: 10px;
        object-fit: cover;
      }
    }
    .pictures {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      justify-content: center;
      .img {
        border-radius: 6px;
        object-fit: cover;
      }
    }
    .facilities-list,
    .services-list {
      display: flex;
      width: 100%;
      height: auto;
      padding: 16px;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 12px;
      border-radius: 14px;
      border: 1px solid #e9e9e9;
      margin-top: 16px;
      @media (max-width: 600px) {
        border: none;
        border-radius: 0;
        padding: 0;
      }
      h3 {
        margin: 0 !important;
      }
    }
    .facilities-list {
      gap: 24px;
    }
    .services-list {
      .item {
        width: auto;
        border-radius: 48px;
        background: #f6f6f6;
        padding: 6px 8px;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .facilities-list {
      .item {
        width: auto;
        color: #323232;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        justify-content: center;
      }
    }
    .flex-start {
      align-items: flex-start;
      justify-content: flex-start;
      gap: 15px;
    }
    .width-auto {
      width: calc(100% - 100px) !important;
    }
    .medical-team-container {
      margin-top: 20px;
      overflow-y: scroll;
    }
    .view-more-button {
      display: block;
      margin: auto;
      color: #121212;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 3px;
      cursor: pointer;
    }
    .medical-team-card:first-child {
      margin-top: 0px;
    }
    .medical-team-card {
      width: 100%;
      height: 233px;
      border-radius: 20px;
      border: 1px solid rgba(228, 228, 228, 1);
      padding: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      justify-content: center;
      margin-top: 17px;
      .arrow {
        ${(p) =>
          p.webConfig.dir === "ltr" &&
          `
                    transform: rotate(180deg);
                `}
      }
      .row-flex {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
        justify-content: flex-start;
      }
      .attendance-container {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 7px;
        justify-content: flex-start;
        width: 100%;
      }
      .header {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 15px;
        height: auto;
        h2 {
          margin: 0 !important;
        }
      }
      .name {
        font-size: 15px;
        font-weight: 700;
        color: rgba(40, 43, 46, 1);
        margin: 0 !important;
        width: 100%;
        @media (max-width: 600px) {
          font-size: 14px;
        }
      }
      .label {
        font-size: 13px;
        font-weight: 500;
        color: rgba(117, 117, 117, 1);
        width: 100%;
        @media (max-width: 600px) {
          font-size: 12px;
        }
      }
      .label,
      .name {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        font-size: 14px;
        font-weight: 700;
        width: 100%;
        color: rgba(65, 65, 65, 1);
        width: auto;
      }
      .span-2 {
        font-size: 12px;
        font-weight: 600;
        color: rgba(65, 65, 65, 1);
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 6px;
      }
      .service {
        margin: 0 !important;
        font-size: 14px;
        font-weight: 400;
        color: rgba(126, 126, 126, 1);
      }
      .attendance {
        font-size: 12px !important;
        font-weight: 400 !important;
        color: rgba(65, 65, 65, 1);
        @media (max-width: 600px) {
          margin-top: 5px;
        }
      }
      .book-button {
        background-color: rgba(41, 188, 171, 1);
        width: 100%;
        height: 40px;
        color: rgba(249, 249, 249, 1);
        border-radius: 7px;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        line-height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 6px;
        justify-content: center;
      }
      .gap-10 {
        gap: 10px;
      }
    }
    .flex-start {
      align-items: flex-start !important;
      justify-content: flex-start !important;
      gap: 0;
    }
    .align-items-center {
      align-items: center !important;
    }
    .width-100 {
      width: 100%;
    }
    .height-53 {
      height: 53px;
    }
    .title {
      color: #121212;
      font-size: 16px;
      font-weight: 600;
      @media (max-width: 600px) {
        font-size: 15px;
      }
    }
    .view-button {
      display: flex;
      flex-direction: row;
      gap: 5px;
      align-items: center;
      justify-content: center;
      color: #29bcab;
      @media (max-width: 800px) {
        font-size: 15px;
      }
      .label {
        color: #29bcab;
        font-size: 16px;
        font-weight: 400;
      }
      .icon {
        width: 20px;
        height: 20px;
        margin-top: 5px;
        color: #29bcab;
      }
    }
    .contact-info-list {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 10px;
      margin-top: 24px;
    }
    .contact-info {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 5px;
      @media (max-width: 800px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
      }
    }
    .work-time-container {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 16px;
      margin-top: 24px;
      flex-wrap: wrap;
    }
    .notif {
      width: 100%;
      padding: 15px;
      color: #254edb;
      background-color: #e2ecff;
      font-size: 13px;
      font-weight: 600;
      border-radius: 8px;
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
    }
    .work-time-box {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      border-radius: 13px;
      border: 1px solid #e9e9e9;
      width: calc(50% - 8px);
      gap: 8px;
      padding: 16px;
      .day,
      .time {
        color: #262626;
        font-size: 14px;
        font-weight: 600;
      }
    }
    .row-flex {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 15px;
    }
    .space-between {
      justify-content: space-between;
      width: 100%;
    }
    .gap-5 {
      gap: 5px;
    }
    .line {
      width: 100%;
      background: #e9e9e9;
      height: 1px;
      margin: 16px 0;
    }
    .gap-8 {
      gap: 8px;
      @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
      }
    }
    .gap-8-center {
      gap: 8px;
      justify-content: center;
    }
    .label {
      color: #637381;
      font-size: 14px;
      font-weight: 500;
    }
    .value {
      color: #212b36;
      font-size: 15px;
      font-weight: 500;
      line-height: 28px;
    }
    .marginT-8 {
      margin-top: 8px;
    }
  }

  .column-flex {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    .box {
      width: 100%;
      background: #fff;
      border-radius: 8px;
      height: auto;
    }
    .padding-16 {
      padding: 16px;
    }
    .padding-0 {
      padding: 0;
    }
    .padding-y-0 {
      padding-top: 0px;
      padding-bottom: 0px;
    }
    .row-flex {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
`;
